<template>
  <el-drawer v-model="model" :size="anchoSidebar" :close-on-click-modal="false" :destroy-on-close="true"
    direction="ltr" header-class="bg-primary text-white py-1" :append-to-body="true" @opened="montarButtonPaypalDetal">
    <template #header>
      <section class="d-flex">
        <h3 class="text-white">Comprar Páginas al Detal</h3>
      </section>
    </template>

    <b-form ref="formValidate">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <template #label>
                <strong>Cant Páginas <span class="text-danger">*</span></strong>
              </template>

              <BFormSpinbutton v-model="cant_paginas" v-bind="cant_paginas_attrs" :min="1" :max="1000"
                :state="!errors.cant_paginas" />

              <b-form-invalid-feedback>
                {{ errors.cant_paginas }}
              </b-form-invalid-feedback>
            </b-form-group>

            <article class="d-flex flex-column align-items-center justify-content-center my-1">
              <h2 class="">Costo por unidad</h2>
              <h1 class="text-primary fs-1">{{ precio_por_pag }}</h1>
            </article>
            <el-divider border-style="dashed"></el-divider>

            <article class="d-flex flex-column align-items-center justify-content-center my-1">
              <h2 class="">Total a Pagar</h2>
              <h1 class=" fs-1 bg-secondary rounded text-white text-center mt-1 precio-total-detal">{{ precio_total }}
              </h1>
            </article>

            <footer class="button-paypal">
              <div id="paypal-button-container-detal"></div>
            </footer>
          </b-col>
        </b-row>
      </b-container>

    </b-form>

  </el-drawer>
</template>

<script setup>
import useUtils from '@composables/useUtils';
import { loadScript } from '@paypal/paypal-js'; 
import useCompraStore from '@/store/compra';
import { currency } from '@/utils/utils';
import useSistemaStore from '@/store/sistema';
import usePlanStore from '@/store/plan';

import { useForm } from 'vee-validate'; 
import { required } from '@validations';
import useUsuarioStore from '@/store/usuario';

const model = defineModel({
  type:Boolean,
  default:false,
});

const plan_store = usePlanStore();

const sistema_store = useSistemaStore();
const usuario_store = useUsuarioStore();
const { sistema } = storeToRefs(sistema_store);


// End Paypal 
const { usuario,usuario_id } = storeToRefs(usuario_store);

const lote_id = ref(null);
const monto_lote = ref(0);
const lote_comprar = ref(null);

const {
  datos_paypal,
  anchoSidebar
} = useUtils();

const { defineField, handleSubmit, resetForm, setErrors, errors } = useForm({
  initialValues: {
    cant_paginas: 1,
  },
  validationSchema: {
    cant_paginas: required
  }
});

const [cant_paginas, cant_paginas_attrs] = defineField('cant_paginas');

const precio_pagina_plan = ref(0);

const cargar_precio_pag_por_plan = () => {
  plan_store.getPrecioPagina(usuario_id.value)
  .then((prec) => {
    precio_pagina_plan.value = prec
  })
}

const precio_por_pag = computed(() => {
  return currency(precio_pagina_plan.value || sistema.value.precio_pagina || 0);
});

const monto_total = computed(() => {
  return cant_paginas.value * (precio_pagina_plan.value || sistema.value.precio_pagina);
});


const precio_total = computed(() => {
  return currency(monto_total.value);
});

const paypalExitoso = (data) => {
  const compra_store = useCompraStore();

  compra_store.comprarPaginasDetal({
    cantidad: cant_paginas.value,
    monto: monto_total.value,
    descripcion: 'Compra de páginas al detal',
    paypal_data: data
  }).then(({ result }) => {
    if (result) {
      usuario_store.refetchUsuario(usuario.value.id);
      resetForm();
      model.value = false;
      swal({
        title: 'Pago exitoso',
        text: `Tu compra se ha realizado con éxito`,
        icon: 'success',
        confirmButtonText: 'OK'
      });
    }

  }).catch((e) => {
    console.log(e)
  })
}


const clienteNoQuisoPagar = () => {
  // toast.info("El cliente no quiso pagar");
}

const montarButtonPaypalDetal = () => {
  cargar_precio_pag_por_plan();
  loadScript(datos_paypal.value)
    .then((paypalObject) => {
      if (paypalObject) {

        paypalObject.Buttons({
          onApprove: paypalExitoso,
          onCancel: clienteNoQuisoPagar,
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{

                amount: {
                  value: String(monto_total.value), // el total
                  currency_code: 'USD',
                  breakdown: {
                    item_total: {
                      value: String(monto_total.value),
                      currency_code: 'USD'
                    }
                  }
                },

                items: [
                  {
                    name: 'Páginas al detal',
                    description: 'Compra de páginas al detal',
                    unit_amount: {
                      value: String(precio_pagina_plan.value || sistema.value.precio_pagina || 0),
                      currency_code: 'USD'
                    },
                    quantity: String(cant_paginas.value)
                  }
                  // Puedes agregar más items aquí si lo necesitas
                ]
              }]
            });
          }
        }).render('#paypal-button-container-detal');
      }
    })
    .catch(error => {
      console.error('Error loading PayPal script:', error);
    });
}

onMounted(() => {
  // cargar_precio_pag_por_plan();
});


</script>

<style lang="scss" scoped>
@import '@variables/variables';

:deep(.badge-page) {
  margin-left: 0px;
  right: 100px;
  top: -7px;
}

.content-reference {
  margin-right: 20px;

  img {
    width: 40px;
    cursor: pointer;

    &:hover {
      // box-shadow: 0px 3px 5px 2px rgba(0, 0, 0, 0.5);
    }
  }
}





.content-popover {
  main {


    .listado-lotes {

      max-height: 380px !important;
      overflow-y: scroll !important;
      padding-right: 10px;

      display: flex;
      flex-direction: column;
      align-items: flex-start;

      ul {
        text-decoration: none;
        padding: 0px;
        width: 100% !important;

        li {
          list-style: none !important;

          &.lote-item {
            height: 100px !important;
            display: flex;
            justify-content: space-between;
            border: 2px solid black;
            margin: 1rem 0px;
            padding: .5rem;
            border-radius: 10px;
            width: 100% !important;
            position: relative;

            &:hover {
              box-shadow: 0px 3px 5px 2px rgba(0, 0, 0, 0.5);
              cursor: pointer;
            }

            &.active {
              border: 5px solid $secondary;

              &::after {
                content: 'Seleccionado';
                position: absolute;
                top: -18px;
                background-color: $primary;
                width: fit-content;
                padding: 5px 10px;
                border-radius: 10px;
                color: white !important;
              }
            }


            .descripcion-content-item {
              flex: 1 1 70%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding-right: 5px;

              h4 {
                color: $dark;
                font-size: 10pt;

                @media (min-width:640px) {
                  font-size: 16pt;
                }
              }

              strong {
                color: $danger ;
                font-size: 12pt;
              }
            }

            .precio-content-item {
              flex: 0 0 30%;
              display: flex;
              flex-direction: column;
              justify-content: center;

              span {
                font-size: 10pt;
                font-weight: bold;
                color: $primary;
                align-self: center;

                @media (min-width:640px) {
                  font-size: 14pt;
                }
              }

              small {
                font-size: 6pt;
                align-self: center;

                @media (min-width:640px) {
                  font-size: 8pt;
                }
              }
            }
          }
        }
      }
    }

    .text-comprar-mas {
      font-size: 12pt;

      &:hover {
        text-decoration: underline;
        color: $primary;
      }

      @media (min-width:640px) {
        font-size: 14pt;
      }
    }
  }
}

.contenido-plan {
  width: calc(100% - 0rem);
  margin: .5rem 0rem;
  height: auto;
  position: relative;
  overflow: hidden;
  border: .3px solid rgba(0, 0, 0, .1);
  padding: 0px;

  .badge-subscrito {
    position: absolute;
    width: auto;
    top: 5px;
    right: 5px;
    background-color: $secondary;
    padding: 5px 20px;
    color: white;
    font-style: bold;
    border-radius: 20px;
    font-size: 12pt;
  }

  &.active,
  &:hover {
    border: 1px solid $primary;
    box-shadow: 5px 5px 10px 3px rgba(0, 0, 0, .4);
  }

  .list-beneficios {
    flex-grow: 1;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-height: 200px;
  }

  .btn-action {
    height: 44px;
    display: flex;
    justify-content: center;

    svg {
      margin-left: 1rem;
    }
  }

  span {
    font-size: 10pt;
  }

  p {
    font-size: 12pt !important;
  }

  .btn-show-opcion {
    position: absolute;
    // z-index: 100;
    top: 1rem;
    right: 1rem;
    left: auto;
    height: 20px;
    width: 20px;
    padding: 0px;

    &:hover {
      background-color: rgba(0, 0, 0, .1);
      box-shadow: 0px 0px 5px rgba(0, 0, 0, .2);

      i,
      svg {
        color: $secondary;
      }
    }
  }

  .opciones-card {
    position: absolute;
    height: 100%;
    width: 80%;
    top: 0;
    right: -80%;
    z-index: 101;
    transition: 60ms ease-in-out;
    background-color: $dark;

    h4 {
      color: white;
    }

    &.show {
      right: 0;
    }

    .card-bio-acciones {
      display: flex;
      justify-content: center;
    }
  }

  @media (min-width:692px) {
    width: calc(100% / 2 - 1rem) !important;
    margin: .5rem;

    span {
      font-size: 12pt;
    }

    p {
      font-size: 14pt !important;
    }
  }

  @media (min-width:992px) {
    width: 350px !important;
  }
}

.button-paypal {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  #paypal-button-container,
  #paypal-button-container-detal {
    width: 90%;

    @media (min-width: 768px) {
      width: 70%;
    }
  }
}

.precio-total-detal {
  padding: .5rem 1rem;
  width: 90%;

  @media (min-width: 768px) {
    width: 70%;
  }
}
</style>